// Находит CompanyUser текущей компании в данных пользователя.
// В разных ответах backend может быть прямой current_company_user или общий
// список company_users, поэтому поддерживаем оба источника.
export function currentCompanyUserIdFromUserData(userData, companyId) {
  const directId = userData?.current_company_user?.id;
  if (directId) return directId;

  const companyUser = userData?.company_users?.find(
    (item) => String(item.company_id) === String(companyId)
  );

  return companyUser?.id || null;
}

// Проверяет, что изменяемый CompanyUser — это запись текущего пользователя
// в активной компании. Это нужно для подтверждения смены собственной роли.
export function isCurrentCompanyUser(companyUserId, userData, companyId) {
  const currentCompanyUserId = currentCompanyUserIdFromUserData(
    userData,
    companyId
  );

  if (!currentCompanyUserId || !companyUserId) return false;

  return String(companyUserId) === String(currentCompanyUserId);
}
